// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3t4bd","requiredAsterisk":"Info_requiredAsterisk__1U9EA"};